export const KFZ_COCKPIT_TEAM_ID = 1214;

// Update this destination when the cockpit moves to Greenhouse.
export const KFZ_COCKPIT_URL =
  'https://demo.nexoya.com/app/da-direkt/5c03d92b9ddfa80d386c901f32758eaba8b17d5f52230abfc476d1f59bd815f2a3fa1cfa4b3.html';
